import { Url } from "../Constants/Url";
import AxiosApiService from "./AxiosService";

export const SupportApiService = {
    getAllServiceRequests, getAllServiceType, fetchCustomerServiceRequestHistory, fetchCustomerServiceRequestDocs,
    downloadCustomerServiceRequestDOC, getCustomerServiceRequest,deleteCustomerServiceRequest, updateCustomerServiceRequestStatus,
    uploadCustomerServiceRequestDocs,getCustomerServiceRequestForEditing,deleteCustomerServiceRequestDoc, fetchCustomerServiceRequestDocsForEditing, 
    fetchUnreadMessageCount,downloadCustomerServiceRequestValueDOC, getAllStatusByServiceTypeId, updateSellRequestFeeDetails, 
    viewCustomerServiceRequestPDF, ExportErrorReport, getSellRequestEditHistory, fetchSellRequestPricingHistory, 
    updateSampleRequestDetails, saveCustomSampleRequest, addCarrier, getCarrierList, getAllTransferRequest, 
    getRequestDetailsById, fetchAllWarehouseUser, updateBarrelProofingDetails, exportBarrelProofingReport, fetchBarrelProofDetails, checkAllBarrelProofingValuePresent,
    updateOwnershipTransferRequestCompanyDetails, getAllDynamicFieldValueByServiceRequestId, exportBarrelValuationReport, updateBarrelValuationDetails, checkAllBarrelValuationValuePresent,
    fetchBarrelValuationDetails, manageScannedBarrels, getFacilityList, addFacility, getTransferRequestDetails, getMashBillList, addMashBill, getWantedToBuyCustomerServiceRequestDetails, getWantedToBuySystemSuggestedDetails,
    fetchBarrelTastingNoteDetails, updateBarrelTastingNoteDetails, checkAllBarrelTastingNoteValuePresent, fetchDestinationBarrelDetails, updateDestinationBarrelDetails, checkAllDestinationBarrelValuePresent, exportTastingReport, fetchAllLogisticRequests
}
// async function getAllServiceRequests(companyId: any, page: any, size: any, filter: any, signal: AbortSignal) {
//     try {
//       const response = await AxiosApiService.getWithParams<any>(Url.GET_CUSTOMER_SUPPORT_REQUESTS, {
//         params: {
//           companyId: companyId,
//           page: page,
//           size: size,
//           name: filter.name,
//           status: filter.status,
//           createdDate: filter.createdDate,
//           requestNumber: filter.requestNumber,
//           requestType: filter.requestType,
//           companyName: filter.companyName
//         },
//         signal: signal // Pass the signal to the Axios request
//       });
  
//       return response;
//     } catch (error) {
//       if (error.name === 'AbortError') {
//         console.log('Request was cancelled');
//       } else {
//         console.error('Error fetching service requests:', error);
//         throw error; // Re-throw the error to handle it in the calling function
//       }
//     }
//   }

async function getAllServiceRequests(companyId: any, page: any, size: any, filter?: any, sortField?: any, sortDirection?: any, signal?: AbortSignal) {
  try {
    const params: Record<string, any> = {
      companyId,
      page,
      size,
      sortField,
      sortDirection,
    };

    // Add filter parameters only if defined
    if (filter) {
      params.name = filter.name;
      params.status = filter.status;
      params.createdDate = filter.createdDate;
      params.requestNumber = filter.requestNumber;
      params.requestType = filter.requestType;
      params.companyName = filter.companyName;
    }

    const response = await AxiosApiService.getWithParams<any>(Url.GET_CUSTOMER_SUPPORT_REQUESTS, {
      params,
      ...(signal ? { signal } : {}), // Include signal only if provided
    });

    return response;
  } catch (error: any) {
    if (error.name === 'AbortError') {
      console.log('Request was cancelled');
    } else {
      console.error('Error fetching service requests:', error);
      throw error;
    }
  }
}

  

async function getAllServiceType() {
    return await AxiosApiService.get<any>(Url.GET_ALL_SERVICE_TYPE);
}

async function fetchCustomerServiceRequestHistory(customerServiceRequestId:any) {
    return await AxiosApiService.get<any>(Url.FETCH_CUSTOMER_SERVICE_REQUEST_HISTORY + '/' + customerServiceRequestId);
}

async function fetchCustomerServiceRequestDocs(customerServiceRequestId:any) {
    return await AxiosApiService.get<any>(Url.FETCH_CUSTOMER_SERVICE_REQUEST_DOCS + '/' + customerServiceRequestId);
}

async function fetchCustomerServiceRequestDocsForEditing(customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.FETCH_CUSTOMER_SERVICE_REQUEST_DOCS_FOR_EDITING + '/' + customerServiceRequestId);
}

async function downloadCustomerServiceRequestDOC(downloadDoc: any) {
    return await AxiosApiService.postBlob<Object>(Url.DOWNLOAD_CUSTOMER_SERVICE_REQUEST_DOC, downloadDoc);
}

async function getCustomerServiceRequest(customerServiceRequestId: any) {
    return await AxiosApiService.get<any>(Url.GET_CUSTOMER_SERVICE_REQUEST + '/' + customerServiceRequestId);
}

async function deleteCustomerServiceRequest(customerServiceRequestId: any) {
    return await AxiosApiService.get(Url.DELETE_CUSTOMER_SUPPORT_REQUEST + '/' + customerServiceRequestId);
}

async function deleteCustomerServiceRequestDoc(id: any) {
  return await AxiosApiService.get(Url.DELETE_CUSTOMER_SUPPORT_REQUEST_DOC + '/' + id);
}

async function updateCustomerServiceRequestStatus(request: any) {
    return await AxiosApiService.post(Url.UPDATE_CUSTOMER_SUPPORT_REQUEST,request);
}

async function getCustomerServiceRequestForEditing(customerServiceRequestId: any) {
  return await AxiosApiService.get<any>(Url.GET_CUSTOMER_SERVICE_REQUEST_FOR_EDITING + '/' + customerServiceRequestId);
}

async function uploadCustomerServiceRequestDocs(fileUpload: any) {
  return await AxiosApiService.post<any>(Url.UPLOAD_CUSTOMER_SERVICE_REQUEST_DOC, fileUpload)
}

async function fetchUnreadMessageCount (customerServiceRequestId: any) {
  return await AxiosApiService.get<any> (Url.FETCH_UNREAD_MESSAGE_COUNT_FOR_CUSTOMER_SERVICE_REQUEST + '/' + customerServiceRequestId);
}

async function downloadCustomerServiceRequestValueDOC(downloadDoc: any) {
  return await AxiosApiService.postBlob<Object>(Url.DOWNLOAD_CUSTOMER_SERVICE_REQUEST_VALUE_DOC, downloadDoc);
}

async function viewCustomerServiceRequestPDF(downloadDoc: any) {
  return await AxiosApiService.postBlob<Object>(Url.SHOW_PDF_FOR_CUSTOMER_SERVICE_REQUEST, downloadDoc);
}

async function getAllStatusByServiceTypeId(serviceTypeId: any, currentStatus:any, isDestinationCompany:any) {
  return await AxiosApiService.getWithParams<any>(Url.GET_ALL_STATUS_BY_SERVICE_TYPE_ID + "/" + serviceTypeId, {params: {
    currentStatus: currentStatus,
    isDestinationCompany: isDestinationCompany
  }});
}

async function ExportErrorReport(exportErrorReportRequest:any) {
  return await AxiosApiService.postBlob<Object>(Url.GET_EXPORT_REPORT, exportErrorReportRequest);
}

async function updateSellRequestFeeDetails(updateFeeDetails:any) {
  return await AxiosApiService.post<any>(Url.UPDATE_SELL_REQUEST_FEE_DETAILS, updateFeeDetails);
}

async function updateSampleRequestDetails(updateFeeDetails:any) {
  return await AxiosApiService.post<any>(Url.UPDATE_SAMPLE_REQUEST_DETAILS, updateFeeDetails);
}

async function updateOwnershipTransferRequestCompanyDetails(updateFeeDetails:any) {
  return await AxiosApiService.post<any>(Url.UPDATE_OWNERSHIP_TRANSFER_COMPANY_DETAILS, updateFeeDetails);
}

async function getAllDynamicFieldValueByServiceRequestId(customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.GET_DYNAMIC_FIELD_VALUE_BY_SERVICE_REQUEST_ID + "/" + customerServiceRequestId);
}

async function getSellRequestEditHistory(requestId: any, historyId:any) {
  return await AxiosApiService.get<any>(Url.GET_SELL_REQUEST_EDIT_HISTORY + "/" + requestId + "/" + historyId);
}
async function fetchSellRequestPricingHistory(customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.FETCH_SELL_REQUEST_PRICING_HISTORY + "/" + customerServiceRequestId);
}

async function addCarrier(request:any) {
  return await AxiosApiService.post<any>(Url.ADD_NEW_CARRIER, request);
}

async function getCarrierList() {
  return await AxiosApiService.get<any>(Url.GET_ALL_CARRIER_LIST);
}

async function getFacilityList() {
  return await AxiosApiService.get<any>(Url.GET_ALL_FACILITY_LIST);
}  

async function addFacility(request:any) {
  return await AxiosApiService.post<any>(Url.ADD_NEW_FACILITY, request);
}

async function getAllTransferRequest(companyId:any) {
  return await AxiosApiService.get<any>(Url.GET_ALL_TRANSFER_REQUEST_LIST + "/" + companyId);
}

async function getRequestDetailsById(id:any) {
  return await AxiosApiService.get<any>(Url.GET_REQUEST_DETAILS_BY_ID + '/' + id);
}
async function saveCustomSampleRequest(requestData:any) {
  return await AxiosApiService.post<any>(Url.SAVE_CUSTOM_SAMPLE_REQUEST, requestData);
}

async function fetchBarrelProofDetails (customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.GET_BARREL_PROOF_DETAILS + '/' + customerServiceRequestId);
}

async function fetchBarrelValuationDetails (customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.GET_BARREL_VALUATION_DETAILS + '/' + customerServiceRequestId);
}

async function updateBarrelProofingDetails(barrelProofingRequest:any) {
  return await AxiosApiService.post<any>(Url.UPDATE_BARREL_PROOFING_DETAILS, barrelProofingRequest);
}

async function updateBarrelValuationDetails(barrelValuationRequest:any) {
  return await AxiosApiService.post<any>(Url.UPDATE_BARREL_VALUATION_DETAILS, barrelValuationRequest);
}

async function exportBarrelProofingReport(exportBarrelProofingRequest: any) {
  return await AxiosApiService.post<any>(Url.EXPORT_BARREL_PROOFING_REPORT, exportBarrelProofingRequest)
}

async function exportBarrelValuationReport(exportBarrelValuationRequest: any) {
  return await AxiosApiService.post<any>(Url.EXPORT_BARREL_VALUATION_REPORT, exportBarrelValuationRequest)
}

async function exportTastingReport(exportTastingRequest: any) {
  return await AxiosApiService.post<any>(Url.EXPORT_TASTING_REPORT, exportTastingRequest)
}

async function fetchAllWarehouseUser() {
    return await AxiosApiService.get<any>(Url.GET_ALL_WAREHOUSE_USER);
}

async function checkAllBarrelProofingValuePresent (customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.CHECK_ALL_BARREL_PROOFING_VALUE_PRESENT + '/' + customerServiceRequestId);
}

async function checkAllBarrelValuationValuePresent (customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.CHECK_ALL_BARREL_VALUATION_VALUE_PRESENT + '/' + customerServiceRequestId);
}

async function manageScannedBarrels(manageScannedBarrels: any) {
  return await AxiosApiService.post<any>(Url.MANAGE_SCANNED_BARRELS, manageScannedBarrels);
}

async function getTransferRequestDetails(customerServiceRequestId: any, transferRequestId: any) {
    return await AxiosApiService.get<any>(Url.CUSTOMER_SERVICE_REQUEST_FOR_TRANSFER + '/' + customerServiceRequestId + '/' + transferRequestId);
}

async function addMashBill(request:any) {
  return await AxiosApiService.post<any>(Url.ADD_NEW_MASH_BILL, request);
}

async function getMashBillList() {
  return await AxiosApiService.get<any>(Url.GET_ALL_MASH_BILL_LIST);
}

async function getWantedToBuyCustomerServiceRequestDetails(customerServiceRequestId: any) {
    return await AxiosApiService.get<any>(Url.WANTED_TO_BUY_CUSTOMER_SERVICE_REQUEST + '/' + customerServiceRequestId);
}

async function getWantedToBuySystemSuggestedDetails(customerServiceRequestId: any) {
    return await AxiosApiService.get<any>(Url.SYSTEM_SUGGESTED_CUSTOMER_SERVICE_REQUEST + '/' + customerServiceRequestId);
}

async function fetchBarrelTastingNoteDetails (customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.GET_BARREL_TASTING_NOTE_DETAILS + '/' + customerServiceRequestId);
}

async function updateBarrelTastingNoteDetails(barrelTastingNoteRequest:any) {
  return await AxiosApiService.post<any>(Url.UPDATE_BARREL_TASTING_NOTE_DETAILS, barrelTastingNoteRequest);
}

async function checkAllBarrelTastingNoteValuePresent (customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.CHECK_ALL_BARREL_TASTING_NOTE_VALUE_PRESENT + '/' + customerServiceRequestId);
}

async function fetchDestinationBarrelDetails (customerServiceRequestId:any) {
  return await AxiosApiService.get<any>(Url.GET_DESTINATION_BARREL_DETAILS + '/' + customerServiceRequestId);
}

async function updateDestinationBarrelDetails(destinationBarrelRequest:any) {
  return await AxiosApiService.post<any>(Url.UPDATE_DESTINATION_BARREL_DETAILS, destinationBarrelRequest);
}

async function checkAllDestinationBarrelValuePresent(customerServiceRequestId:any, ServiceType: any) {
  return await AxiosApiService.get<any>(Url.CHECK_ALL_DESTINATION_BARREL_VALUE_PRESENT + '/' + customerServiceRequestId + '/' + ServiceType);
}

async function fetchAllLogisticRequests(logisticType: any, page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_ALL_LOGISTIC_REQUEST, 
        {
            logisticType: logisticType,
            page: page,
            size: size,
            sortField: sortField, 
            sortDirection: sortDirection
        }, filter, { signal });
}